import { create } from 'zustand'

/**
 * Состояние оболочки: то, что принадлежит хосту, а не микрофронтам.
 *
 * Счётчики непрочитанного живут здесь, а не в кэше запросов, потому что
 * их источник — сокет, а не запрос. Класть в TanStack Query данные,
 * которые никто никогда не запрашивает, значит врать про их природу.
 */

export type AppSurface = 'social' | 'spaces'

interface AppUiState {
  /** Мобильный сайдбар в Sheet. */
  sidebarOpen: boolean
  /**
   * Модальное окно настроек (ремоут `settings`). Открыто = смонтировано:
   * URL при этом не меняется, экран под модалкой живёт дальше — как
   * в Discord. Закрытие приходит событием SETTINGS_CLOSE_EVENT.
   */
  settingsOpen: boolean
  /** Какая половина приложения открыта — соцсеть или спейсы. */
  activeSurface: AppSurface
  unreadBySpace: Record<string, number>

  setSidebarOpen: (open: boolean) => void
  setSettingsOpen: (open: boolean) => void
  setActiveSurface: (surface: AppSurface) => void
  setSpaceUnread: (spaceId: string, unreadCount: number) => void
}

export const useAppUiStore = create<AppUiState>()((set) => ({
  sidebarOpen: false,
  settingsOpen: false,
  activeSurface: 'social',
  unreadBySpace: {},

  setSidebarOpen: (sidebarOpen) => {
    set({ sidebarOpen })
  },
  setSettingsOpen: (settingsOpen) => {
    set({ settingsOpen })
  },
  setActiveSurface: (activeSurface) => {
    set({ activeSurface })
  },
  setSpaceUnread: (spaceId, unreadCount) => {
    set((state) => ({ unreadBySpace: { ...state.unreadBySpace, [spaceId]: unreadCount } }))
  },
}))
